import { createContext } from 'react';

/**
 * React context providing responsive viewport information.
 *
 * Defaults to a mobile-first state to be safe during SSR or when media queries
 * are not yet resolved.
 *
 * @category Contexts
 */
const ViewportContext = createContext({
    isMobile: true,
    isTablet: false,
    isDesktop: false,
    viewport: 'mobile',
});

export { ViewportContext };
//# sourceMappingURL=ViewportContext.js.map
